module.exports = __webpack_public_path__ + "img/case_2.07976064.png";